import { defineStore } from 'pinia'
import { ref } from 'vue'
import { sessionStorage } from '@shared/helpers/storage'
import Corporate from '@shared/data/models/corporate.js'

export const useCorporateStore = defineStore(
  'corporate',
  () => {
    // State
    /** @type {import('vue').Ref<Corporate|null>} */
    const corporate = ref(null)

    return {
      // State
      corporate,
    }
  },
  {
    persist: {
      storage: sessionStorage,
      serializer: {
        serialize: (state) => {
          const rawState = { ...state }
          if (rawState.corporate) {
            rawState.corporate = rawState.corporate._json
          }
          return JSON.stringify(rawState)
        },
        deserialize: (value) => {
          const parsed = JSON.parse(value)
          // Reconstruct Corporate (to restore non-primitive properties)
          if (parsed.corporate) {
            parsed.corporate = new Corporate(parsed.corporate)
          }
          return parsed
        },
      },
    },
  },
)

export default useCorporateStore
